import script from "./TableReturn.vue?vue&type=script&setup=true&lang=js"
export * from "./TableReturn.vue?vue&type=script&setup=true&lang=js"

import "./TableReturn.vue?vue&type=style&index=0&id=1c3203d2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c3203d2"]])

export default __exports__